import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import Login from './components/authentication/Login';

Login().then(res => {
  if (res.login) {
    ReactDOM.render(<App />, document.getElementById('root'));
  }
});




// WEBPACK FOOTER //
// ./src/index.js